import { BLACK, DARK_GREY, GREY, SCOUT_BLUE, WHITE } from '../../../ThemeContext/constants';
import { theme } from '../../../ThemeContext/ThemeObject';
import {
  compactPrimaryButtonFixedWidthStyles,
  compactPrimaryButtonNarrowStyles,
  modalPrimaryButtonPaddedStyles,
  tealGhostButtonWideStyles
} from '../../shared/commonStyles';

import type { IStyle } from '../../../ThemeContext/ThemeObject';

export const classes: IStyle = {
  dragArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '18px',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: GREY,
    backgroundColor: '#F3F3F3',
    outline: `3px solid ${WHITE}`,
    height: '340px',
    width: '100%',
    borderRadius: '8px',
    marginBottom: '30px',
    transition: 'all 0.3s ease-in-out'
  },
  dragAreaOver: {
    backgroundColor: '#ECECEC',
    outline: `3px solid ${SCOUT_BLUE}`
  },
  selectFilesButton: compactPrimaryButtonFixedWidthStyles,
  selectFilesGoogleButton: tealGhostButtonWideStyles,
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '500px'
  },
  dragAreaSingle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '12px',
    fontWeight: '600',
    color: GREY,
    backgroundColor: '#F3F3F3',
    outline: `2px solid ${WHITE}`,
    height: '90px',
    width: '320px',
    borderRadius: '8px',
    padding: '8px',
    transition: 'all 0.3s ease-in-out'
  },
  dragAreaOverSingle: {
    backgroundColor: '#ECECEC',
    outline: `2px solid ${SCOUT_BLUE}`
  },
  dragAreaWithGoogleDrive: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '12px',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '12px',
    fontWeight: 'bold',
    color: GREY,
    backgroundColor: '#F3F3F3',
    outline: `3px solid ${WHITE}`,
    height: '150px',
    width: '100%',
    borderRadius: '8px',
    transition: 'all 0.3s ease-in-out'
  },
  selectFilesButtonSingle: compactPrimaryButtonNarrowStyles,
  fileIconContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '90%'
  },
  fileIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '20px',
    backgroundColor: '#084D6D10',
    '& svg': {
      color: theme.palette.primary.main
    }
  },
  fileName: {
    color: theme.palette.primary.main,
    fontSize: '15px',
    fontWeight: 'bold',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '196px'
  },
  fileSize: {
    color: '#999999'
  },
  formDateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  formDatePickerStyles: {
    width: '284px',
    borderRadius: '6px',
    margin: '3px',
    '& button': {
      transform: 'translate(-4px, -1.5px)',
      outline: 'none'
    }
  },
  inputLabel: {
    color: `${DARK_GREY} !important`,
    fontSize: '16px',
    fontFamily: 'Source Sans Pro, sans-serif',
    overflowWrap: 'anywhere',
    marginBottom: '8px',
    '& span': {
      marginLeft: '2px'
    }
  },
  questionLabel: {
    color: `${BLACK} !important`,
    fontSize: '14px',
    fontFamily: 'Source Sans Pro, sans-serif',
    overflowWrap: 'anywhere'
  },
  // Explanatory copy under a question whose real control lives outside React
  // (e.g. RefereeListField's server-rendered rows).
  questionHint: {
    color: DARK_GREY,
    fontSize: '13px',
    fontFamily: 'Source Sans Pro, sans-serif',
    marginTop: '4px'
  },
  questionInputLabel: {
    color: '#838383 !important',
    fontSize: '13px',
    fontFamily: 'Source Sans Pro, sans-serif',
    '& span': {
      color: theme.palette.error.main,
      marginLeft: '2px'
    }
  },
  questionDateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& div': {
      paddingBottom: '8px'
    }
  },
  questionsRankInput: {
    '& div': {
      marginLeft: '0'
    }
  },
  lookUpButton: {
    ...modalPrimaryButtonPaddedStyles,
    color: 'rgb(91,196,191)',
    background: 'rgb(91,196,191,0.12)',
    height: '41px',
    marginLeft: '16px'
  }
};
